export default __webpack_public_path__ + "static/media/22t.9c5c4b61.jpg";